import { Fragment, useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import ServiceReviews from './ServiceReviews'
import { gettext, ngettext } from 'common/language'
import ModalWrapper from 'common/modals/ModalWrapper'
import formatPrice from 'common/utils/formatPrice'
import classNames from './styles.module.scss'


ServiceReviewBadgeView.propTypes = {
  rating: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  reviewCount: PropTypes.number.isRequired,
}

export default function ServiceReviewBadgeView({ rating, percentage, reviewCount }) {
  const [show, setShow] = useState(false)
  const showBadgeModal = useCallback(() => {
    setShow(true)
  }, [])
  const hideBadgeModal = useCallback(() => {
    setShow(false)
  }, [])
  return (
    <Fragment>
      <button className={classNames.serviceBadge} onClick={showBadgeModal}>
        <div className={classNames.percentage}>
          <span>{percentage}</span>
          <span>%</span>
        </div>
        <div className={classNames.badgeCol}>
          <p>
            {gettext('All Customers would recommend Boa Lingua')}
          </p>
          <p>
            {formatPrice(reviewCount)} {ngettext('Review', 'Reviews', reviewCount)}
          </p>
        </div>
      </button>
      <ModalWrapper
        show={show}
        onHide={hideBadgeModal}
        component={ServiceReviews}
        rating={rating}
        reviewCount={reviewCount}
        maskClosable={false}
        title={gettext('Boa Lingua Reviews')}
        modalClassName={classNames.serviceModal}
        key="modal-dialog"
        withTrigger
      />
    </Fragment>
  )
}
